import React from "react";
import PropTypes from 'prop-types';

import "./../../css/search-box.css";

//const SUCCESS_BOX = "success";
//const ERROR_BOX = "error";

var myTimer = null;

export class SearchBoxComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value || ""
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.stopTimer = this.stopTimer.bind(this);
    }

    componentDidMount() {
        // TODO
    }

    componentWillUnmount() {
        this.stopTimer();
    }

    stopTimer() {
        if (myTimer !== null) {
            clearTimeout(myTimer);
            myTimer = null;
        }
    }

    handleChange(event) {
        this.stopTimer();
        this.setState({value: event.target.value});

        if (event.target.value.length === 0 || event.target.value.trim().length > 1) {
            myTimer = setTimeout(this.handleSearch, 1000);
        }
    }

    handleSearch() {
        if (this.state.value.length === 0 || this.state.value.trim().length > 1) {
            this.stopTimer();
            this.props.search(this.state.value);
        }
    }

    render() {
        return (
            <div className="search-box-component">
                <input type="text" name={this.props.name} value={this.state.value} onChange={this.handleChange} placeholder={this.props.placeholder} />
                <label onClick={this.handleSearch}><i className="fa fa-search" aria-hidden="true"></i></label>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/widgets/Common/SearchBoxComponent.js